import type { ImmerStateCreator } from 'hooks/useStore';
import type { TicketField, TicketFieldOption } from '../_api/types';

export interface TicketFieldSlice {
  showTicketModal: boolean;
  setShowTicketModal: (show: boolean) => void;
  showArchiveModal: boolean;
  setShowArchiveModal: (show: boolean) => void;
  selectedData: TicketField | null;
  setSelectedData: (data: TicketField | null) => void;
  isArchivedfieldStatus: boolean;
  setIsArchivedfieldStatus: (status: boolean) => void;
  isStatusConfirmationChecked: boolean;
  setIsStatusConfirmationChecked: (status: boolean) => void;
  showArchivedStatusOptionModal: boolean;
  setShowArchivedStatusOptionModal: (status: boolean) => void;
  selectedStatusOptions: TicketFieldOption[];
  setSelectedStatusOptions: (ticketFields: TicketFieldOption[]) => void;
  cycleTimeConfigsByStatusOptions: TicketField[];
  setCycleTimeConfigsByStatusOptions: (configs: TicketField[]) => void;
  isStatusOptionConfirmationChecked: boolean;
  setIsStatusOptionConfirmationChecked: (status: boolean) => void;
  refetchTableData: (() => void) | null;
  setRefetchTableData: (refetchFn: (() => void) | null) => void;
}

export const useTicketFieldSlice: ImmerStateCreator<TicketFieldSlice> = (
  set
) => ({
  showTicketModal: false,
  setShowTicketModal: (show: boolean) =>
    set(
      (state) => {
        state.ticketFieldSlice.showTicketModal = show;
      },
      false,
      'setShowTicketModal'
    ),
  showArchiveModal: false,
  setShowArchiveModal: (show: boolean) =>
    set(
      (state) => {
        state.ticketFieldSlice.showArchiveModal = show;
      },
      false,
      'setShowArchiveModal'
    ),
  selectedData: null,
  setSelectedData: (data: TicketField | null) =>
    set(
      (state) => {
        state.ticketFieldSlice.selectedData = data;
      },
      false,
      'setSelectedData'
    ),
  isArchivedfieldStatus: false,
  setIsArchivedfieldStatus: (status: boolean) =>
    set(
      (state) => {
        state.ticketFieldSlice.isArchivedfieldStatus = status;
      },
      false,
      'setIsArchivedfieldStatus'
    ),
  isStatusConfirmationChecked: false,
  setIsStatusConfirmationChecked: (status: boolean) =>
    set(
      (state) => {
        state.ticketFieldSlice.isStatusConfirmationChecked = status;
      },
      false,
      'setIsStatusConfirmationChecked'
    ),
  showArchivedStatusOptionModal: false,
  setShowArchivedStatusOptionModal: (status: boolean) =>
    set(
      (state) => {
        state.ticketFieldSlice.showArchivedStatusOptionModal = status;
      },
      false,
      'setShowArchivedStatusOptionModal'
    ),
  selectedStatusOptions: [],
  setSelectedStatusOptions: (ticketFieldOptions: TicketFieldOption[]) =>
    set(
      (state) => {
        state.ticketFieldSlice.selectedStatusOptions = ticketFieldOptions;
      },
      false,
      'setSelectedStatusOptions'
    ),
  cycleTimeConfigsByStatusOptions: [],
  setCycleTimeConfigsByStatusOptions: (configs: TicketField[]) =>
    set(
      (state) => {
        state.ticketFieldSlice.cycleTimeConfigsByStatusOptions = configs;
      },
      false,
      'setCycleTimeConfigsByStatusOptionIds'
    ),
  isStatusOptionConfirmationChecked: false,
  setIsStatusOptionConfirmationChecked: (status: boolean) =>
    set(
      (state) => {
        state.ticketFieldSlice.isStatusOptionConfirmationChecked = status;
      },
      false,
      'setIsStatusOptionConfirmationChecked'
    ),
  refetchTableData: null,
  setRefetchTableData: (refetchFn: (() => void) | null) =>
    set(
      (state) => {
        state.ticketFieldSlice.refetchTableData = refetchFn;
      },
      false,
      'setRefetchTableData'
    ),
});
